module.exports = __webpack_public_path__ + "b6c21db7355a03afdd8b59415b1eb9ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/assets/logo-no-text.png
// module id = 2811
// module chunks = 1